/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`

export default function LiveTagIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 23 14" css={Color} className="live-tag-icon">
      <g id="그룹_44759" data-name="그룹 44759" transform="translate(-132 -411)">
        <text id="LIVE" transform="translate(143.5 421)" fill="#dc2323" fontSize="8"
              fontFamily="Roboto-Black, Roboto" fontWeight="800">
          <tspan x="-8.256" y="0">LIVE</tspan>
        </text>
        <g id="사각형_11309" data-name="사각형 11309" transform="translate(132 411)" fill="none" stroke="#dc2323"
           strokeWidth="1">
          <rect width="23" height="14" rx="3" stroke="none"/>
          <rect x="0.5" y="0.5" width="22" height="13" rx="2.5" fill="none"/>
        </g>
      </g>
    </svg>
  )
}
